<template>
  <van-popup v-model="showPicker" position="bottom">
    <van-picker
      :columns="names"
      :loading="loading"
      :show-toolbar="true"
      @cancel="cancelItem"
      @confirm="pickItem"/>
  </van-popup>
</template>

<script>
import { getAreaApi } from '@/api/base'

import {
  Popup,
  Picker
} from 'vant';

export default {
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },

  data() {
    return {
        showPicker: false,
        loading: true,
        area_name: [],
        area_id: 0,
        names: [],
        list: []
    };
  },
  methods: {
    showDialog(isShow) {
        this.showPicker = isShow
        this.area_id=0
        this.getData()
    },
    getData() {
        var that = this
        this.axios.get(getAreaApi + (this.area_id==0? '' : '/?parent=' + that.area_id)).then(function (ret) {
            if (ret.length == 0) {
                that.$emit('pickData', { areaName: that.area_name.join(''), areaID: that.area_id })
                that.showPicker = false
                return
            }
            that.list = ret
            that.names = []
            ret.forEach((it) => {
                that.names.push(it.name)
            })
            that.loading = false
        }).catch(function (error) {
            that.loading = false
            console.log(error)
        })
    },
    // ok(value, index) {
    //     this.level = this.level + 1
    //     this.area_name.push(this.list[index].name)
    //     this.area_id = this.list[index].id
    //     if (this.level == 4) {
    //         this.$emit('pickData', { areaName: this.area_name.join(''), areaID: this.area_id })
    //         this.showPicker = false
    //         this.level = 0
    //         this.area_name = []
    //         this.area_id = 0
    //     } else {
    //         this.getData()
    //     }
    // },
    pickItem(value, index) {
        this.area_name.push(this.list[index].name)
        this.area_id = this.list[index].id
        this.getData()
    },
    cancelItem() {
      this.showPicker = false
    }
  }
};
</script>

<style lang="less">
</style>
